import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
} from "antd";
import {
    dineroDisabledMask,
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    ButtonItem,
    round6Decimals,
    DatePickerItem,
    SwitchItem,
    InputItem,
} from "../../../../Components/Items";
import VentasForm from "../../../../Components/VentasForm";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import notaDeCreditoVentaFPdf from "../../../../Pdf/notadeCreditoVentaFPdf";
import notaDeCreditoVentaRPdf from "../../../../Pdf/notaDeCreditoVentaRPdf";
import MandarCorreoNotaDeCreditoVenta from "../MandarCorreoNotaDeCreditoVenta/MandarCorreoNotaDeCreditoVenta";
import { DollarOutlined, DownloadOutlined, SendOutlined } from "@ant-design/icons";
import PagosNotaDeCreditoVenta from "../PagosNotaDeCreditoVenta/PagosNotaDeCreditoVenta";
import ModalAcuseCancelacionNota from "../ModalAcuseCancelacionNota/ModalAcuseCancelacionNota";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

moment.locale("es");

class VerNotaDeCreditoVenta extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoProveedores: null,
        todasProveedores: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoInsumos: (
            <Option disabled value={0} key={0}>
                Seleccione un proveedor primero
            </Option>
        ),
        todasInsumos: [],
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        valuesForm: null,
        id: this.props.location.state.id,
        datosVenta: null,
        tipoDeCambioVenta: 0,
        totalVenta: 0,
        totalPagarVenta: 0,
        subtotalVenta: 0,
        arrayImpuestosVenta: [],
        arrayRetencionesVenta: [],
        modalCorreo: false,
        modalCorreoId: null,
        total: 0,
        totalPagar: 0,
        totalPagado: 0,
        subtotal: 0,
        ajusteSubtotal: 0,
        arrayImpuestos: [],
        arrayRetenciones: [],
        modalPagos: false,
        modalAcuseCancelacion: false,
        // null hasta que llegue la nota: con 0 el boton "Cancelación" saldria mientras carga.
        estado: null,
        objetoBancos: null,
        todasBancos: null,
        todasVentas: [],
        facturaGlobalDeId: null,
    };
    async componentDidMount() {
        this.setState({ loading: true });
        await this.consultarTodo()
        this.setState({ loading: false });
    }

    promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

    async consultarTodo() {

        this.setState({ loading: true });

        await axios
            .post(
                "notasDeCreditoVenta/selectDatosParaNotaDeCredito",
                { empresaId: this.props.empresaId, notaId: this.state.id },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasClientes: res.data.clientes,
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasFormasDePago: res.data.formasDePago,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasBancos: res.data.bancosYCajas,
                        todasInsumos: res.data.insumosVenta,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        objetoClientes: res.data.clientes.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.stringBuscar}
                                </Option>
                            );
                        }),
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoInsumos: res.data.insumosVenta.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre || value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoBancos: res.data.bancosYCajas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                } else {
                    message.warning('No se encontro informacion de la venta')
                }
            });

        await axios
            .post(
                "notasDeCreditoVenta/datosNota",
                { empresaId: this.props.empresaId, notaId: this.state.id },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    message.error("Error no se encontro informacion de la nota de credito");
                } else {
                    this.formRef.current.setFieldsValue({
                        ...res.data,
                        fechaNota: moment(res.data.fechaNota),
                        factura: res.data.factura ? 1 : 2,
                        clienteId: res.data.facturaGlobalDeId ? "publicoEnGeneral" : res.data.clienteId,
                        insumos: res.data.insumos.map(insumo => {
                            const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / insumo.cantidad)
                            return { ...insumo, precioUnitarioConImpuestos }
                        })
                    });

                    this.setState({ estado: res.data.estado, total: res.data.total, totalPagar: res.data.totalPagar, totalPagado: res.data.totalPagado, subtotal: res.data.subtotal, arrayImpuestos: res.data.arrayImpuestos, arrayRetenciones: res.data.arrayRetenciones, ajusteSubtotal: res.data.ajusteSubtotal, facturaGlobalDeId: res.data.facturaGlobalDeId || null })
                }
            });

        this.setState({ loading: false });

    }

    atras() {
        this.props.history.goBack();
    }
    async onChangeInsumoProyecto(value, key, tipo) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
        );
        // if(tipo === 'insumo'){
        //   function getAllIndexes(arr, val) {
        //     var indexes = [], i = -1;
        //     while ((i = arr.indexOf(val, i+1)) != -1){
        //         indexes.push(i);
        //     }
        //     return indexes;
        // }
        // }
        if (!insumo) return;
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }
        const precio = insumo.precios.find(
            (valuePrecios) => valuePrecios.precioId?.toString() === precioId
        );
        if (precio) {
            arrayValue[key].precioUnitario = precio.precio;
        } else {
            message.info("Este insumo no tiene ese precio");
            arrayValue[key].precioUnitario = 0;
        }

        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }
        }

        this.formRef.current.setFieldsValue({
            insumos: arrayValue
        });
        this.setState({ flete: (!!insumo.flete || this.state.flete) })
    }
    async onChangePrecioCantidadDescuento(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.usoDeCFDIID) {
            objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
        }
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
            objetoCambiar.vendedorId = cliente.vendedorId
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            }
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
    }
    onChangeContado(value) {
        if (value !== 1) {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d6d'
            })
        } else {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d58'
            })
        }
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        if (!clienteId) return;
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === clienteId
        );
        this.formRef.current.setFieldsValue({
            precioId: value === 1 ? cliente.precioContadoId : cliente.precioCreditoId,
        });
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    }
    cerrarMandarCorreoNotaDeCreditoVenta() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
    }
    abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
        if (proyectoId) {
            this.setState({
                modalElegirMarbetes: true,
                modalElegirMarbetesIndex: value,
                modalElegirMarbetesMarbetes: marbetes || [],
                modalElegirMarbetesInsumoId: insumoId,
                modalElegirMarbetesProyectoId: proyectoId
            })
        } else {
            message.warning('Elegir un proyecto para elegir marbetes')
        }
    }
    cerrarElegirMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirMarbetes: false,
            modalElegirMarbetesIndex: null,
            modalElegirMarbetesMarbetes: null,
            modalElegirMarbetesInsumoId: null,
            modalElegirMarbetesProyectoId: null
        })
    }

    descargarNota(value) {
        axios
            .post(
                "notasDeCreditoVenta/datosPdf",
                { notaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.factura) {
                    var xmltext = res.data.respuestaFactura.data.cfdi;
                    const dataSat = res.data.respuestaFactura.dataSat
                    const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )'

                    var filename = nombreArchivo + ".xml";
                    var pom = document.createElement("a");
                    var bb = new Blob([xmltext], { type: "text/plain" });

                    pom.setAttribute("href", window.URL.createObjectURL(bb));
                    pom.setAttribute("download", filename);

                    pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(
                        ":"
                    );
                    pom.draggable = true;
                    pom.classList.add("dragout");

                    pom.click();

                    const pdf = notaDeCreditoVentaFPdf(res.data);

                    pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                } else {
                    const dataSat = res.data.respuestaFactura.dataSat
                    const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )'

                    const pdf = notaDeCreditoVentaRPdf(res.data);

                    pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                }
            });
    }

    enviarNota(value) {
        this.setState({ modalCorreo: true, modalCorreoId: value });
    }

    cerrarPagosNotaDeCreditoVenta() {
        this.consultarTodo()
        this.setState({
            modalPagos: false,
        });
    }

    getInsumosColumns() {
        return [
        { title: "Clave",  width: "5%" },
        { title: "Insumo", width: "13%" },
        { title: "Unidad", width: "5%" },
        { title: "Proyecto", width: "9%" },
        { title: "PU", width: "9%" },
        { title: "Precio Neto", width: "9%" },
        { title: "Cant.", width: "7%" },
        { title: "Desc.", width: "8%" },
        { title: "Subtotal / Impuesto / Total", width: "10%" },
        ];
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
        return (
            <React.Fragment key={key}>
                <tr className="fila-insumo">
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                                const insumoSeleccionado = this.state.todasInsumos?.find(
                                    (insumo) => insumo._id.toString() === insumoId?.toString()
                                );
                                return (
                                    <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                                        {insumoSeleccionado?.clave || '-'}
                                    </div>
                                );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border" style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        <FormItem
                            {...restField}
                            name={[name, "insumoId"]}
                            required
                            noStyle
                        >
                            <SelectItem
                                sinBorde
                                autoFocus
                                disabled
                                noDisabledBackground
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo"
                                esTabla
                                style={{ boxShadow: 'none', whiteSpace: 'normal', wordBreak: 'break-word', height: 'auto', minHeight: '32px' }}
                                onChange={(value) =>
                                    this.onChangeInsumoProyecto(value, arrayKey, 'insumo')
                                }
                            >
                                {this.state.objetoInsumos}
                            </SelectItem>
                        </FormItem>
                    </td>
                     <td className="td-border">
                                <FormItem noStyle shouldUpdate>
                                  {({ getFieldValue }) => {
                                    const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                                    const insumoSeleccionado = this.state.todasInsumos?.find(
                                      (insumo) => insumo._id.toString() === insumoId?.toString()
                                    );
                                    return (
                                    <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                                        {insumoSeleccionado?.unidad || '-'}
                                      </div>
                                    );
                                  }}
                                </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem
                            shouldUpdate={(prev, curr) =>
                                prev.proyectoId !== curr.proyectoId
                            }
                            noStyle
                        >
                            {({ getFieldValue }) => {
                                const proyectoId = getFieldValue("proyectoId");
                                return (
                                    <FormItem
                                        {...restField}
                                        name={[name, "proyectoId"]}
                                        required
                                        noStyle
                                        initialValue={proyectoId}
                                    >
                                        <SelectItem
                                            sinBorde
                                            disabled
                                            noDisabledBackground
                                            width="100%"
                                            placeholder="Proyecto"
                                            style={{ boxShadow: 'none' }}
                                            onChange={(value) =>
                                                this.onChangeInsumoProyecto(value, arrayKey, 'proyecto')
                                            }
                                        >
                                            {this.state.objetoProyectos}
                                        </SelectItem>
                                    </FormItem>
                                );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "precioUnitario"]}
                            noStyle
                            required
                            numberCero
                        >
                            <InputNumberItem
                                sinBorde
                                disabled
                                onChange={(value) =>
                                    this.onChangePrecioCantidadDescuento(value, arrayKey)
                                }
                                placeholder="Precio Unitario"
                                dinero
                            />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "precioUnitarioConImpuestos"]}
                            noStyle
                            required
                        >
                            <InputNumberItem
                                sinBorde
                                disabled
                                placeholder="Precio Unitario con Impuestos"
                                dineroDisabled
                            />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem
                            noStyle
                            shouldUpdate={(prev, curr) =>
                                prev.insumos[arrayKey]?.cantidadProyecto !==
                                curr.insumos[arrayKey]?.cantidadProyecto
                            }
                        >
                            {({ getFieldValue }) => {
                                const insumos = getFieldValue("insumos");
                                const cantidadProyecto = insumos[arrayKey].cantidadProyecto;
                                let max = 0;
                                if (cantidadProyecto === "No inventariable") {
                                    max = Infinity;
                                } else {
                                    max = cantidadProyecto;
                                }
                                return (
                                    <FormItem
                                        {...restField}
                                        name={[name, "cantidad"]}
                                        number
                                        noStyle
                                        type="number"
                                    >
                                        <InputNumberItem
                                            sinBorde
                                            disabled
                                            placeholder={
                                                max && max !== Infinity
                                                    ? "Max: " + max
                                                    : "Cantidad"
                                            }
                                            onChange={(value) =>
                                                this.onChangePrecioCantidadDescuento(value, arrayKey)
                                            }
                                        />
                                    </FormItem>
                                );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "descuento"]}
                            required
                            numberCero
                            noStyle
                            initialValue={0}
                        >
                            <InputNumberItem
                                sinBorde
                                disabled
                                placeholder="Descuento"
                                porcentaje
                                max={100}
                                onChange={(value) =>
                                    this.onChangePrecioCantidadDescuento(value, arrayKey)
                                }
                            />
                        </FormItem>
                    </td>
                        {/* Columna: Subtotal / Impuesto / Total */}
                    <td className="td-border">
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                        const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                        const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                        const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;
        
                        return (
                            <div className="celda-totales" style={{ fontSize: '13px' }}>
                                <div className="celda-totales" style={{ fontSize: '12px' }}>
                                  <div>{dineroDisabledMask(subtotal)}</div>
                                  <div>{dineroDisabledMask(impuestos)}</div>
                                  <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                                </div>
                            </div>
                        );
                        }}
                    </FormItem>
        
                    {/* Campos hidden para mantener los valores en el form */}
                    <FormItem {...restField} name={[name, "subtotal"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "impuestos"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "total"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    </td>
                </tr>

                {/* Fila de Leyenda */}
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                {({ getFieldValue }) => {
                    let arrayValue = getFieldValue("insumos");
                    if (arrayValue && arrayValue[arrayKey]?.leyenda) {
                    return (
                        <tr className="fila-leyenda">
                        <td colSpan="9" className="td-border">
                            <div className="contenedor-leyenda">
                            <div className="texto-leyenda">
                                <b>Leyenda:</b> {arrayValue[arrayKey].leyenda}
                            </div>
                            </div>
                        </td>
                        </tr>
                    );
                    }
                }}
                </FormItem>
        
        
                {/* Fila de Observaciones */}
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml)}>
                {({ getFieldValue }) => {
                    const arrayValue = getFieldValue("insumos") || [];
                    if (arrayValue && arrayValue[arrayKey]?.observaciones) {
                    return (
                        <tr className="fila-observaciones">
                        <td colSpan="9" className="td-border">
                            <div className={`contenedor-observaciones ${arrayValue[arrayKey].observacionesXml ? 'con-xml' : 'sin-xml'}`}>
                            <div className="texto-observaciones">
                                {String(arrayValue[arrayKey].observaciones)
                                .split(/\r?\n/)
                                .map((line, i) => <span key={i}>{line}<br /></span>)}
                            </div>
                            </div>
                        </td>
                        </tr>
                    );
                    }
                    return null;
                }}
                </FormItem>
            </React.Fragment>
        );
    }

    guardarConcepto() {
        axios
            .post(
                "notasDeCreditoVenta/editarConcepto",
                {
                    notaDeCreditoId: this.state.id,
                    empresaId: this.props.empresaId,
                    concepto: this.formRef.current?.getFieldValue("concepto"),
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success !== 2) {
                    message.warning("Error al guardar el concepto");
                } else {
                    message.success("Concepto actualizado");
                }
            })
            .catch(() => {
                message.error("Error al guardar el concepto");
            });
    }

    getObservacionesConfig() {
        return {
            observaciones: {
                value: this.formRef.current?.getFieldValue("observaciones"),
                onSave: (newValue) => {
                    this.formRef.current?.setFieldsValue({ observaciones: newValue });
                    this.forceUpdate();
                       // Guardar en backend en segundo plano
                        axios
                        .post("notasDeCreditoVenta/editarObservaciones", {
                            notaDeCreditoId: this.state.id,
                            empresaId: this.props.empresaId,
                            observaciones: newValue,
                        })
                        .then((res) => {
                            if (res.data.success !== 2) {
                                message.warning("Error al guardar observaciones");
                            } else {
                                message.success("Observaciones actualizadas");
                            }
                        })
                        .catch(() => {
                            message.error("Error al guardar observaciones");
                        });
                },
            },
            checkboxes: [
                {
                    label: "Imprimir",
                    name: "imprimirObservaciones",
                    onChange: (e) => {
                        axios
                        .post("notasDeCreditoVenta/editarImprimirObservaciones", {
                            notaDeCreditoId: this.state.id,
                            empresaId: this.props.empresaId,
                            imprimirObservaciones: e.target.checked,
                        })
                        .then((res) => {
                            if (res.data.success !== 2) {
                            message.info("La nota de crédito no se edito");
                            }
                        });
                    }
                }
            ],
            totales: (
                <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                                Subtotal
                            </th>
                            <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                                {dineroDisabledMask(this.state.subtotal)}
                            </td>
                        </tr>
                    </tbody>
                    {this.state.arrayImpuestos.map((valueArray, index) => (
                        <tbody key={index}>
                            <tr>
                                <th className="th-totales" style={{ fontSize: "16px" }}>{valueArray.descripcionFactura}</th>
                                <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(valueArray.totalImpuestos)}</td>
                            </tr>
                        </tbody>
                    ))}
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
                            <td className="td-totales-right" style={{ fontSize: "16px" }}>
                                {dineroDisabledMask(this.state.total)}
                            </td>
                        </tr>
                    </tbody>
                    {this.state.arrayRetenciones.map((value, index) => (
                        <tbody key={index}>
                            <tr>
                                <th className="th-totales" style={{ fontSize: "18px" }}>{value.descripcionFactura}</th>
                                <td className="td-totales-right" style={{ fontSize: "18px" }}>{dineroDisabledMask(value.totalRetenciones)}</td>
                            </tr>
                        </tbody>
                    ))}
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ fontSize: "17px" }}>Total a Pagar</th>
                            <td className="td-totales-right" style={{ fontSize: "17px" }}>
                                {dineroDisabledMask(this.state.totalPagar)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            )
        };
    }

    render() {
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Ver Nota de Credito Venta"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                        padding: "10px 12px",
                        fontSize: "12px",
                    }}
                />
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin spinning={this.state.loading} style={{ display: "block", margin: "0 0 0 auto" }}>
                        <Form
                            ref={this.formRef}
                            name="verNotaDeCreditoVenta"
                            layout
                        >
                            <VentasForm
                                datosGeneralesContent={(
                                    <>
                                        <Row gutter={[16, 8]} align="middle">
                                            <Col xs={24} sm={24} md={10} lg={10}>
                                                <FormItem
                                                    label="Cliente"
                                                    name="clienteId"
                                                    margin
                                                    required
                                                    labelCol={{ span: 4 }}
                                                    wrapperCol={{ span: 20 }}
                                                >
                                                    <SelectItem
                                                        disabled
                                                        noDisabledBackground
                                                        placeholder="Cliente"
                                                        onChange={(valueId) => this.onChangeCliente(valueId)}
                                                    >
                                                        {this.state.facturaGlobalDeId && (
                                                            <Option value="publicoEnGeneral" key="publicoEnGeneral">
                                                                PUBLICO EN GENERAL
                                                            </Option>
                                                        )}
                                                        {this.state.objetoClientes}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col xs={12} sm={8} md={5} lg={5}>
                                                <FormItem
                                                    required
                                                    initialValue={2}
                                                    name="factura"
                                                    label="Tipo"
                                                    labelCol={{ span: 8}}
                                                    wrapperCol={{ span: 16}}
                                                    margin
                                                >
                                                    <SelectItem
                                                        disabled
                                                        noDisabledBackground
                                                        width="100%"
                                                        value={this.state.factura}
                                                        onChange={(value) => {
                                                            this.formRef.current.setFieldsValue({
                                                                fechaNota: moment(),
                                                            })
                                                            this.setState({ factura: value })
                                                        }}
                                                    >
                                                        <Option value={2}>Remisión</Option>
                                                        {this.props.permisoFacturarVentas && this.props.certificada && (
                                                            <Option value={1}>Factura</Option>
                                                        )}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col xs={12} sm={8} md={5} lg={5}>
                                                <FormItem
                                                    label="Fecha"
                                                    name="fechaNota"
                                                    required
                                                    margin
                                                    initialValue={moment()}
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha de Nota"
                                                        allowClear={false}
                                                    />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                        <Row gutter={[16, 8]}>
                                            <Col xs={24} sm={24} md={10} lg={10}>
                                                <FormItem
                                                    label="Vendedor"
                                                    name="vendedorId"
                                                    margin
                                                    required
                                                    labelCol={{ span: 4 }}
                                                    wrapperCol={{ span: 20 }}
                                                >
                                                    <SelectItem disabled noDisabledBackground placeholder="Vendedor">
                                                        {this.state.objetoUsuarios}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col xs={12} sm={8} md={5} lg={5}>
                                                <FormItem
                                                    label="Proyecto"
                                                    name="proyectoId"
                                                    margin
                                                    required
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <SelectItem placeholder="Proyecto" disabled noDisabledBackground>
                                                        {this.state.objetoProyectos}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col xs={12} sm={8} md={5} lg={5}>
                                                <FormItem
                                                    name="precioId"
                                                    label="Precio"
                                                    margin
                                                    required
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <SelectItem placeholder="Precio" disabled noDisabledBackground>
                                                        {this.state.objetoPrecios}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                        <Row gutter={[16, 8]} align="middle">
                                            <Col xs={18} sm={18} md={10} lg={10}>
                                                <FormItem
                                                    label="Concepto"
                                                    name="concepto"
                                                    margin
                                                    pattern
                                                    labelCol={{ span: 4 }}
                                                    wrapperCol={{ span: 20 }}
                                                >
                                                    <InputItem placeholder="Concepto" />
                                                </FormItem>
                                            </Col>
                                            <Col xs={6} sm={6} md={4} lg={4}>
                                                <ButtonItem type="primary" blanco onClick={() => this.guardarConcepto()}>
                                                    Guardar
                                                </ButtonItem>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            datosClienteCol={{ xs: 24, sm: 24, md: 12, lg: 10, xl: 10, xxl: 8 }}
                                datosClienteContent={(
                                    <FormItem shouldUpdate noStyle>
                                        {({ getFieldValue }) => {
                                            const devolverDinero = getFieldValue('devolverDinero')
                                            return (
                                                <>
                                                    <FormItem
                                                        name="pagarVenta"
                                                        label="Pagar Venta"
                                                        tooltip={{ title: "Pagar la venta existente con esta devolucion" }}
                                                        margin
                                                        valuePropName="checked"
                                                        labelCol={{ span: 14 }}
                                                        wrapperCol={{ span: 10 }}
                                                    >
                                                        <SwitchItem disabled />
                                                    </FormItem>
                                                    <FormItem
                                                        name="devolverDinero"
                                                        label="Compensación"
                                                        tooltip={{ title: "Regresar el dinero al cliente" }}
                                                        margin
                                                        valuePropName="checked"
                                                        labelCol={{ span: 14 }}
                                                        wrapperCol={{ span: 10 }}
                                                    >
                                                        <SwitchItem disabled />
                                                    </FormItem>
                                                    {devolverDinero && (
                                                        <FormItem
                                                            required
                                                            margin
                                                            name="bancoId"
                                                            label="Banco"
                                                            labelCol={{ span: 14 }}
                                                            wrapperCol={{ span: 10 }}
                                                        >
                                                            <SelectItem disabled noDisabledBackground placeholder="Banco">
                                                                {this.state.objetoBancos}
                                                            </SelectItem>
                                                        </FormItem>
                                                    )}
                                                </>
                                            )
                                        }}
                                    </FormItem>
                                )}
                                 formaDePagoCol={{ xs:24, sm:24, md:12, lg:8, xl:10, xxl:8 }}
                                formaDePagoContent={(
                                    <>
                                        {(() => {
                                            const factura = this.formRef.current?.getFieldValue("factura");
                                            return (
                                                <Row gutter={[6, 4]}>
                                                    <Col span={24}>
                                                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.contado !== curr.contado}>
                                                            {({ getFieldValue }) => {
                                                                return (
                                                                    <FormItem
                                                                        name="formaDePagoId"
                                                                        label="F Pago"
                                                                        initialValue="6125149afe07662acc100d58"
                                                                        margin
                                                                        required
                                                                        labelCol={{ span: 8 }}
                                                                        wrapperCol={{ span: 14 }}
                                                                    >
                                                                        <SelectItem disabled noDisabledBackground placeholder="Forma de Pago">
                                                                            {this.state.objetoFormasDePago}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                )
                                                            }}
                                                        </FormItem>
                                                    </Col>
                                                    {factura === 1 && (
                                                        <Col span={24}>
                                                            <FormItem
                                                                name="usoDeCfdiId"
                                                                label="Uso CFDI"
                                                                margin
                                                                required
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 14 }}
                                                            >
                                                                <SelectItem disabled noDisabledBackground placeholder="Uso de CFDI">
                                                                    {this.state.objetoUsosDeCFDI}
                                                                </SelectItem>
                                                            </FormItem>
                                                        </Col>
                                                    )}
                                                </Row>
                                            );
                                        })()}
                                    </>
                                )}

                                monedaContent={(
                                    <>
                                        <FormItem
                                            required
                                            margin
                                            name="monedaId"
                                            label="Moneda"
                                            initialValue='60c7e4396465ad440c41c15a'
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 14 }}
                                        >
                                            <SelectItem disabled noDisabledBackground onChange={(value) => {
                                                if (value === '60c7e4396465ad440c41c15a') {
                                                    this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                }
                                            }} placeholder="Moneda">
                                                {this.state.objetoMonedas}
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) =>
                                                prevValues.monedaId !== currentValues.monedaId
                                            }
                                        >
                                            {({ getFieldValue }) => {
                                                const monedaId = getFieldValue("monedaId");
                                                if (monedaId === "60c7e4396465ad440c41c15a") {
                                                    return null;
                                                }
                                                return (
                                                    <FormItem
                                                        required
                                                        number
                                                        margin
                                                        label="T. Cambio"
                                                        name="tipoDeCambio"
                                                        type="number"
                                                        initialValue={1}
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <InputNumberItem disabled dinero placeholder="T. Cambio" />
                                                    </FormItem>
                                                );
                                            }}
                                        </FormItem>
                                        <FormItem shouldUpdate noStyle>
                                            {({ getFieldValue }) => {
                                                const pagarVenta = getFieldValue('pagarVenta')
                                                const devolverDinero = getFieldValue('devolverDinero')
                                                if (pagarVenta || devolverDinero) {
                                                    return (
                                                        <>
                                                            <p style={{ textAlign: 'center' }}>Moneda de la venta: {this.state.datosVenta?.moneda?.abreviacion}</p>
                                                            <FormItem
                                                                required
                                                                number
                                                                margin
                                                                label={`T. C. ${this.state.datosVenta?.moneda?.abreviacion ? this.state.datosVenta?.moneda?.abreviacion : ''}`}
                                                                name="tipoDeCambioVenta"
                                                                type="number"
                                                                initialValue={1}
                                                            >
                                                                <InputNumberItem
                                                                    disabled
                                                                    dinero
                                                                    placeholder={`T. C. ${this.state.datosVenta?.moneda?.abreviacion ? this.state.datosVenta?.moneda?.abreviacion : ''}`}
                                                                />
                                                            </FormItem>
                                                            <p style={{ textAlign: 'center' }}>Tipo de cambio venta: {dineroDisabledMask(this.state.datosVenta?.tipoDeCambio)}</p>
                                                        </>
                                                    )
                                                }
                                            }}
                                        </FormItem>
                                    </>
                                )}

                                showDoctor={false}
                                showRegimenFiscal={false}
                                monedaCol={{ xs: 24, sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }}
                                showMoneda={true}
                                monedaEnFila2={true}
                                gutter={[20, 16]}

                                tabs={[
                                    {
                                        key: "tabla",
                                        label: "Insumos",
                                        listName: "insumos",
                                        columns: this.getInsumosColumns(),
                                        renderRow: this.renderInsumoRow.bind(this),
                                    }
                                ]}
                                defaultActiveKey="tabla"
                                isMobile={window.innerWidth <= 1000}
                                formInstance={this.formRef.current}

                                observacionesConfig={this.getObservacionesConfig()}
                                totalPagar={this.state.totalPagar}

                                actionButtons={(
                                    <>
                                        {this.state.totalPagado > 0 &&
                                            <ButtonItem
                                                type="primary"
                                                icon={<DollarOutlined />}
                                                verdeB
                                                onClick={() => this.setState({ modalPagos: true })}
                                            >
                                                Pagos
                                            </ButtonItem>
                                        }
                                        {this.state.estado === 0 &&
                                            <ButtonItem
                                                type="primary"
                                                rojoB
                                                onClick={() => this.setState({ modalAcuseCancelacion: true })}
                                            >
                                                Cancelación
                                            </ButtonItem>
                                        }
                                        <ButtonItem
                                            icon={<DownloadOutlined />}
                                            arenaB
                                            onClick={() => this.descargarNota(this.state.id)}
                                        >
                                            Descargar
                                        </ButtonItem>
                                        <ButtonItem
                                            type="primary"
                                            icon={<SendOutlined />}
                                            azulMB
                                            onClick={() => this.enviarNota(this.state.id)}
                                        >
                                            Mandar Correo
                                        </ButtonItem>
                                        <ButtonItem
                                            type="primary"
                                            rojoB
                                            onClick={this.atras.bind(this)}
                                        >
                                            Regresar
                                        </ButtonItem>
                                    </>
                                )}
                            />
                        </Form>
                    </Spin>
                </div>
                <MandarCorreoNotaDeCreditoVenta
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoNotaDeCreditoVenta={this.cerrarMandarCorreoNotaDeCreditoVenta.bind(this)}
                />
                <PagosNotaDeCreditoVenta
                    visible={this.state.modalPagos}
                    id={this.state.id}
                    cerrarPagosNotaDeCreditoVenta={this.cerrarPagosNotaDeCreditoVenta.bind(this)}
                />
                <ModalAcuseCancelacionNota
                    visible={this.state.modalAcuseCancelacion}
                    notaId={this.state.id}
                    cerrarModalPdf={() => this.setState({ modalAcuseCancelacion: false })}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        certificada: state.empresa.certificada,
    };
};

export default connect(mapStateToProps)(VerNotaDeCreditoVenta);